import type { DemoSet } from '../../types'
import { skuMasterDataAuditorInsight } from './insight'
import {
  skuIntakeAuditorMockJobDetail,
  skuIntakeAuditorMockJobs,
} from './mockJobs'
import { skuMasterDataAudit } from './scripts/skuMasterDataAudit'

/**
 * SKU Master Data Auditor — the catalog / master-data chair of the Cascade 3PL
 * world (see `sets/cascade-3pl` = ops, `sets/invoice-audit` = finance).
 * Persona: Jordan Castillo, COO. First-touch, file-based wedge: drop two
 * exports the team already has — the catalog and last quarter's ShipHero
 * billing export — and out comes the ~$756K/yr the SKU data is quietly costing
 * Cascade, ranked SKU by SKU, with the corrected catalog already drafted.
 * Zero integration. See `docs/demos/sku-master-data-auditor.md`.
 *
 * SHARED WORLD with `cascade-3pl` + `invoice-audit`: same company, revenue
 * band, FCs, carriers, and brands. MONEY FIREWALL: this set's dollars are
 * "absorbed rating deltas" (carrier billed correctly on measured actuals;
 * Cascade rated its brands off bad master data and ate the gap) — a DISTINCT
 * concept from invoice-audit's disputable leakage and cascade-3pl's carrier
 * claims. Numbers live in `./data.ts`.
 *
 * Single-flow set: one chat script, four beats, one prospective chat-hero
 * insight, one standing mock agent. No dashboards (cold-start file wedge).
 */
export const skuMasterDataAuditorSet: DemoSet = {
  id: 'sku-master-data-auditor',
  name: 'Cascade 3PL — Catalog',
  description:
    'SKU Master Data Auditor — catalog / master-data chair of the Cascade 3PL world. Zero-integration file wedge: drop a catalog export + last quarter’s ShipHero billing export, get the ~$756K/yr absorbed in DIM/weight rating deltas ranked SKU by SKU, the corrected catalog drafted, and a standing intake auditor so it never decays again. Single flow, four beats.',
  scripts: [skuMasterDataAudit],
  insight: skuMasterDataAuditorInsight,
  userPersona: {
    firstName: 'Jordan',
    lastName: 'Castillo',
  },
  mockJobs: skuIntakeAuditorMockJobs,
  mockJobDetail: skuIntakeAuditorMockJobDetail,
}
